import ChevronRight from "@mui/icons-material/ChevronRight";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DataObject from "@mui/icons-material/DataObject";
import Delete from "@mui/icons-material/Delete";
import ExtensionIcon from "@mui/icons-material/Extension";
import StoageIcon from "@mui/icons-material/Storage";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import {
  Alert,
  Box,
  Button,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { writeTable } from "../../../api/table";
import { useAppId } from "../../../hook";
import { useAppIdMap } from "../../../hook/app";
import { useMenu, UseMenuProps } from "../../../hook/menu";
import {
  useSelectedNotebookPageId,
  useSelectedNotebookPageIdMap,
} from "../../../hook/page";
import {
  useAddDatabaseView,
  useDatabaseView,
  useDeleteDatabaseView,
  useSelectedDatabaseViewId,
  useSetDatabaseView,
} from "../../../hook/page/view";
import { NotebookMoreMenuSelection } from "../../../types/notebook/database";
import {
  PageView,
  PageViewType,
  pageViewTypeLabels,
  pageViewTypes,
} from "../../../types/notebook/view";
import { ComponentSelectMenu } from "../component";
import { Component } from "../../../types/component";
import { setDatabasePagesToComponent } from "../../../api/component";
import { UploadCsvMenu } from "../database/uploadCsvMenu";
import { AddBoardViewMenuContent } from "../../page/view/board";
import { PropertiesMenu } from "./property";
const Papa = require("papaparse");

// export const NotebookMoreMenuContent: React.FC<{
//   menuSelection: NotebookMoreMenuSelection;
//   onClose: () => void;
//   setMenuSelection: (selection: NotebookMoreMenuSelection) => void;
// }> = ({ menuSelection, onClose, setMenuSelection }) => {
//   switch (menuSelection) {
//     case NotebookMoreMenuSelection.MAIN:
//       return (
//         <NotebookMoreMenuPrimary
//           onClose={onClose}
//           setMenuSelection={setMenuSelection}
//         />
//       );
//     // case NotebookMoreMenuSelection.PROPERTIES:
//     //   return <PropertiesMenu setMenuSelection={setMenuSelection} />;
//     // case NotebookMoreMenuSelection.ADD_PROPERTY:
//     //   return <AddPropertyMenuItems setMenuSelection={setMenuSelection} />;
//     // case NotebookMoreMenuSelection.PROPERTY:
//     //   return <PropertyViewMenu setMenuSelection={setMenuSelection} />;
//   }
//   return <></>;
// };

export const NotebookMoreMenu: React.FC<UseMenuProps> = ({
  open,
  onClose,
  anchorEl,
}) => {
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  const {
    anchorEl: anchorElUploadFile,
    open: openUploadFile,
    handleOpen: handleOpenUploadFile,
    onClose: onCloseUploadFile,
    setAnchorEl: setAnchorElUploadFile,
  } = useMenu();
  const {
    anchorEl: anchorElSelectComponent,
    open: openSelectComponent,
    handleOpen: handleOpenSelectComponent,
    onClose: onCloseSelectComponent,
    setAnchorEl: setAnchorElSelectComponent,
  } = useMenu();
  const {
    anchorEl: anchorElProperties,
    open: openProperties,
    handleOpen: handleOpenProperties,
    onClose: onCloseProperties,
    setAnchorEl: setAnchorElProperties,
  } = useMenu();
  const elRef = useRef<HTMLElement | null>(null);

  // useEffect(() => {
  //   if (!elRef.current) return;
  //   setAnchorElProperties(elRef.current);
  // }, [elRef.current]);

  return (
    <Menu
      onClose={onClose}
      anchorEl={anchorEl}
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <PropertiesMenu
        anchorEl={anchorElProperties}
        onClose={onCloseProperties}
        open={openProperties}
      />
      <ComponentSelectMenu
        anchorEl={anchorElSelectComponent}
        onClose={onCloseSelectComponent}
        open={openSelectComponent}
        onChange={async (comp) => {
          setDatabasePagesToComponent({
            "component-id": comp["component-id"],
            "folder-id": selectedNotebookPageId!,
          });
        }}
      />
      <UploadCsvMenu
        anchorEl={anchorElUploadFile}
        onClose={onCloseUploadFile}
        open={openUploadFile}
      />
      <MenuItem disabled>
        <ListItemText>Page Settings</ListItemText>
      </MenuItem>
      <MenuItem
        sx={{ width: "15rem" }}
        onClick={handleOpenProperties}
        // ref={(r) => {
        //   elRef.current = r;
        // }}
      >
        <ListItemIcon>
          <DataObject color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>Properties</ListItemText>
        <ListItemSecondaryAction>
          <IconButton color="primary">
            <ChevronRight />
          </IconButton>
        </ListItemSecondaryAction>
      </MenuItem>
      <MenuItem
        sx={{ width: "15rem" }}
        onClick={(e) => {
          handleOpenUploadFile(e);
        }}
      >
        <ListItemIcon>
          <StoageIcon color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>Upload Data File</ListItemText>
      </MenuItem>
      <MenuItem
        sx={{ width: "15rem" }}
        onClick={(e) => {
          handleOpenSelectComponent(e);
        }}
      >
        <ListItemIcon
        // ref={(e: any) => {
        //   setAnchorElSelectComponent(e);
        // }}
        >
          <ExtensionIcon color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>Set Component</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export const AddDatabaseViewMenuContent: React.FC<{
  viewData: PageView;
  setViewData: (viewData: PageView) => void;
  folderId: string;
}> = ({ viewData, setViewData, folderId }) => {
  const viewType = viewData["view-type"];
  switch (viewType) {
    case PageViewType.BOARD:
      return (
        <AddBoardViewMenuContent
          viewData={viewData}
          folderId={folderId}
          setViewData={setViewData}
        />
      );
  }
  return <></>;
};

export const AddDatabaseViewMenu: React.FC<
  UseMenuProps & { folderId: string }
> = ({ folderId, anchorEl, onClose, open }) => {
  const [appId] = useAppId();
  if (!appId) {
    throw new Error("No App Id!");
  }
  const [view, setViewData] = useState<PageView>({
    name: "View",
    "view-type": PageViewType.TABLE,
    type: "omega/query-omega/page/view/PageView",
    "page-id": folderId,
    "app-id": appId,
  });
  const addDatabaseView = useAddDatabaseView();

  const setType = (value: PageViewType) => {
    setViewData({ ...view, "view-type": value });
  };

  const setName = (value: string) => {
    setViewData({ ...view, name: value });
  };

  return (
    <>
      <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
        <Paper
          elevation={7}
          sx={{
            padding: "2rem",
            width: "20rem",
            gap: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography>Add View</Typography>
          <TextField
            value={view["name"]}
            onChange={(e) => {
              setName(e.target.value);
            }}
            label="Name"
          ></TextField>
          <FormControl>
            <InputLabel id="view-type-label">Type</InputLabel>
            <Select
              labelId="view-type-label"
              value={view["view-type"]}
              label="Type"
              onChange={(e) => {
                setType(e.target.value as PageViewType);
              }}
            >
              {pageViewTypes.map((viewType) => {
                const label = pageViewTypeLabels[viewType];
                return (
                  <MenuItem key={viewType} value={viewType}>
                    {label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <AddDatabaseViewMenuContent
            folderId={folderId}
            viewData={view}
            setViewData={setViewData}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
          >
            <Button
              onClick={() => {
                addDatabaseView(view);
                onClose();
              }}
            >
              Add
            </Button>
          </Box>
        </Paper>
      </Menu>
    </>
  );
};

export const DatabaseViewMenu: React.FC<
  UseMenuProps & { viewId: string | undefined; folderId: string }
> = ({ onClose, anchorEl, folderId, open, viewId }) => {
  const view = useDatabaseView(viewId);
  const viewName = view?.name;
  const deleteView = useDeleteDatabaseView();
  const setView = useSetDatabaseView();
  const setName = (name: string) => {
    if (!view) return;
    if (!folderId) return;
    if (!view) return;
    const newView: PageView = { ...view, name };
    setView({ view: newView, pageId: folderId });
  };

  return (
    <Menu open={open} onClose={onClose} anchorEl={anchorEl}>
      <MenuList>
        <MenuItem disableRipple>
          <TextField
            value={viewName}
            onChange={(e) => setName(e.target.value)}
            variant="standard"
            autoFocus
            fullWidth
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (!viewId) return;
            deleteView({
              viewId,
              pageId: folderId,
            });
            onClose();
          }}
        >
          <ListItemIcon>
            <Delete color="primary" fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
